import React from 'react';
import {Button} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {useSelector} from "react-redux";

function BusinessListPageActions() {
    const navigate = useNavigate();
    const isRootUser = useSelector(state => state?.user?.user?.is_root_user)

    const handleCreateAction = () => {
        navigate('/business-profiles/create');
    };

    return (<>
        {(isRootUser && (
            <Button
                id="create-business-profile"
                key="add-new-business"
                variant="contained"
                color="primary"
                onClick={handleCreateAction}
            >
                + Create New Business
            </Button>))}
    < />);
}

export default BusinessListPageActions;
